import { useState, useRef } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL, } from "firebase/storage";

import RenderIf from "../RenderIf";
import Carging from "../Carging";

const Galery = ({ list, onChange }) => {

    const [images, setImages] = useState(list);
    const [isCarging, setIsCarging] = useState(false);

    const fileRef = useRef();
    const storage = getStorage();
    
    const remove = (index) => {
        const newImages = [...images];
        newImages.splice(index, 1);
        setImages(newImages);  
        onChange({ target: { name: "galeria", value: newImages } })
    }

    const handleChange = (e) => {
        setIsCarging(true);
        const file = e.target.files[0];
        const reader = new FileReader();

        let imgRef = ref(storage, `images/${Date.now()}.png`);

        uploadBytes(imgRef, file)
            .then(url => {
                return getDownloadURL(imgRef);
            })
            .then(url => {
                let newImages = [...images, url];
                setImages(newImages);
                
                onChange({
                    target: {
                        name: "galeria",
                        value: newImages
                    }
                });
                setIsCarging(false);
            })
    }

    return (
        <ul className="galery">
            {images?.map((image, index) => (
                <li key={index} >
                    <img
                        src={image}
                        alt="galery image"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                    <div>
                        <i className="bi bi-trash" onClick={(e) => remove(index)}></i>
                    </div>
                </li>
            ))}
            <li
                className="bg-light border"
                onClick={() => fileRef.current.click()}

            >
                <RenderIf  condition={! isCarging }>
                    <i className="bi bi-plus" />
                </RenderIf>

                <RenderIf  condition={ isCarging }>
                    <Carging />
                </RenderIf>


            </li>
            <input
                ref={fileRef}
                type="file"
                accept="image/*"
                className="d-none"
                onChange={(e) => handleChange(e) }
            />

        </ul>
    )

}
export default Galery;